import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IPreferredSupplier } from '../interfaces/preferred-supplier';
import { IPreferredSupplierFilter } from '../interfaces/preferred-supplier-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class PreferredSupplierService extends EditService<
  IPreferredSupplier,
  IPreferredSupplierFilter
> {
  url = '/api/preferredsuppliers';
  entityTitle = 'PreferredSupplier';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  create(preferredSub: IPreferredSupplier): Promise<any> {
    let successMsg =
      typeof preferredSub.id != undefined && preferredSub.id != 0
        ? 'Supplier updated.'
        : 'Supplier added.';

    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.handleRequest(
      this.http.post(this.url + '/save', preferredSub, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  getPage(filterCommand: IPreferredSupplierFilter): Promise<any> {
    /*const params = new URLSearchParams();
        Object.keys(filterCommand).forEach(prop => {
            if (Array.isArray(filterCommand[prop])) {
                (filterCommand[prop] as any[]).forEach((p, i) => {
                    params.set(`${prop}[${i}]`, p);
                });
            } else {
                params.set(prop, filterCommand[prop]);
            }
        });*/
    return this.handleRequest(
      this.http.get(this.url + '/getpage', { params: this.constructHttpParams(filterCommand) }),
      this.handlersFactory.getForReadByFilter(),
    );
  }
}
